export enum CookieName {
    ROBLEX_CALCULATOR = 'roblex-calculator',
}
